/**
 * Returns a new object with the specified keys from the original object.
 * If the key does not exist in the original object, it is ignored and not included in the new object.
 */
export const pick = function(props: any, keys: string[] | Set<string>): any {
    const selectPropsKeys = keys instanceof Set ? keys : new Set(keys);
    return Object.fromEntries(
        Object.entries(props).filter(([key]) => selectPropsKeys.has(key))
    );
}

export const omit = function(props: any, keys: string[] | Set<string>): any {
    const selectPropsKeys = keys instanceof Set ? keys : new Set(keys);
    return Object.fromEntries(
        Object.entries(props).filter(([key]) => !selectPropsKeys.has(key))
    );
}

export const merge = function(obj1: any, obj2: any) {
    if (obj1 === undefined) return obj2;
    if (obj2 === undefined) return obj1;
    if (obj2===null) return obj2;
    const result = {} as any;
    const combined = { ...obj1, ...obj2 };
    for(let k in combined) {
        if (combined[k] && typeof(combined[k])==='object' && !Array.isArray(combined[k])) {
            result[k] = merge(obj1[k], obj2[k]);
        } else { 
            result[k] = obj2 && k in obj2? obj2[k] : obj1[k]
        }
    }
    return result;
}
  